<template>
	<div class="sale-person-form">
		<p class="title">New Customer Type</p>
		<form v-on:submit.prevent="handleFormSubmitted">
			<div class="input-ctn">
				<div class="label">Name</div>
				<input v-model="name" type="text" class="input" placeholder="Name" />
			</div>
			<button type="submit" class="btn submit">Create</button>
		</form>
	</div>
</template>

<script>
export default {
	name: "NewCustomerTypeForm",
	props: ["addCustomerType"],

	data() {
		return {
			loading: false,
			name: "",
            phoneNumber: ""
		};
	},
	methods: {
		async handleFormSubmitted() {
			this.loading = true;
			await this.addCustomerType({ name: this.name, phoneNumber: this.phoneNumber });
			this.loading = false;
		},
	},
};
</script>

<style></style>
